module.exports = __webpack_public_path__ + "img/illustration-img.8935624d.png";